import { render } from "./PanelMain.vue?vue&type=template&id=6a581543&scoped=true"
import script from "./PanelMain.vue?vue&type=script&lang=js"
export * from "./PanelMain.vue?vue&type=script&lang=js"

import "./PanelMain.vue?vue&type=style&index=0&id=6a581543&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a581543"]])

export default __exports__